// services/studentService.js
const API_BASE_URL = `${process.env.REACT_APP_API_URL}`;

export const studentService = {
  async fetchStudentRecords(searchParams = {}, signal = null, type = "placementEligible") {
    try {
      // Build query parameters
      const params = new URLSearchParams();

      // Add pagination parameters with defaults
      params.append('page', searchParams.page || 1);
      params.append('limit', searchParams.limit || 10);

      // Add search parameters
      if (searchParams.searchField && searchParams.searchValue) {
        params.append('searchField', searchParams.searchField);
        params.append('searchValue', searchParams.searchValue);
      }

      // Add filters
      if (searchParams.departments) params.append('departments', searchParams.departments);
      if (searchParams.skillsKnown) params.append('skillsKnown', searchParams.skillsKnown);
      if (searchParams.courses) params.append('courses', searchParams.courses);
      if (searchParams.branches) params.append('branches', searchParams.branches);
      if (searchParams.companyLocations) params.append('companyLocations', searchParams.companyLocations);
      if (searchParams.experiences) params.append('experiences', searchParams.experiences);
      if (searchParams.resumeStatus) params.append('resumeStatus', searchParams.resumeStatus);
      if (searchParams.genders) params.append('genders', searchParams.genders);
      if (searchParams.fromPassedYear) params.append('fromPassedYear', searchParams.fromPassedYear);
      if (searchParams.toPassedYear) params.append('toPassedYear', searchParams.toPassedYear);
      if (searchParams.readyForPlacement) {
        params.append('readyForPlacement', searchParams.readyForPlacement);
      }

      const queryString = params.toString();
      const getEndpoint = (type) => {
        switch (type) {
          case "getAll":
            return "/students-record";   // ✅ FIXED
          case "placementEligible":
            return "/placement-ready";
          case "mentor":
            return "/mentor/students";
          default:
            return "/placement-ready";
        }
      };

      const endpoint = getEndpoint(type);

      const url = `${API_BASE_URL}${endpoint}?${queryString}`;
      console.log('Fetching URL:', url);
      console.log('Search params:', searchParams);

      const token = localStorage.getItem('token');

      const fetchOptions = {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      };

      // Add abort signal if provided
      if (signal) {
        fetchOptions.signal = signal;
      }

      const response = await fetch(url, fetchOptions);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('API Response:', result);

      if (result.success && result.data) {
        return {
          data: result.data,
          pagination: result.pagination || {
            currentPage: 1,
            totalPages: 1,
            totalRecords: result.data.length,
            recordsPerPage: result.data.length,
            recordsOnCurrentPage: result.data.length
          },
          totalRecords: result.pagination?.totalRecords || result.data.length
        };
      } else {
        return {
          data: [],
          pagination: {
            currentPage: 1,
            totalPages: 1,
            totalRecords: 0,
            recordsPerPage: 10,
            recordsOnCurrentPage: 0
          },
          totalRecords: 0
        };
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        throw error; // Re-throw abort errors
      }
      console.error('Error fetching student records:', error);
      throw new Error('Failed to fetch student records. Please try again later.');
    }
  },

  // Update a student record
  async updateStudentRecord(studentData) {
    try {
      // Debug: Log the student data being sent
      console.log('Student data being sent:', studentData);
      console.log('ProgressStatus value:', studentData.ProgressStatus);
      console.log('ProgressStatus type:', typeof studentData.ProgressStatus);

      // First, update the student record
      const response = await fetch(`${API_BASE_URL}/students-record/${studentData.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(studentData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const updatedRecord = await response.json();

      // Check for ProgressStatus with correct casing
      if (studentData.ProgressStatus !== undefined && studentData.ProgressStatus !== null && studentData.ProgressStatus !== '') {
        console.log('Updating registration with ProgressStatus:', studentData.ProgressStatus);

        try {
          const token = localStorage.getItem('token');

          const registrationResponse = await fetch(`${process.env.REACT_APP_API_URL}/registrations/${studentData.studentId}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              studentProgressStatus: studentData.ProgressStatus,
            }),
          });

          if (!registrationResponse.ok) {
            console.warn(`Failed to update registration record: ${registrationResponse.status}`);
          } else {
            console.log('Registration record updated successfully');
          }
        } catch (registrationError) {
          console.error('Error updating registration record:', registrationError);
        }
      } else {
        console.log('ProgressStatus not found or undefined, skipping registration update');
      }

      return updatedRecord;
    } catch (error) {
      console.error('Error updating student record:', error);
      throw new Error('Failed to update record. Please try again.');
    }
  }
};